<script>
    export default {
        name:'pagefilter',
        render(h){
            let tds=this.$slots.default.map(d=>{
                var d1=d;
                let show=true;
/*                if (d.props!=null)
                {   
                    let label=d.props.label;
                    show=(d.props.show!=false);
                    let show=(d.data.directives==null)||d.data.directives.reduce((vis,dir)=>(vis && ((dir.name!='show')||(dir.value))),true);
                    if (label!=null)
                        d1=h('span',{ class:'has-float-label' },[
                            show?h('label',{ for:d.props.id+'_label' },[label]):"",
                            h('div',{ id:d.props.id+'_label' },[d])
                        ]);
                }*/
              if ((d.data!=null)&&(d.data.attrs!=null))
              {
                let label=d.data.attrs.label;
//                show=(d.data.attrs.show!=false);
                let show=(d.data.directives==null)||d.data.directives.reduce((vis,dir)=>(vis && ((dir.name!='show')||(dir.value))),true);
                if (label!=null)
                  d1=h('span',{ class:'has-float-label' },[
                    show?h('label',{ for:d.data.attrs.id+'_label' },[label]):"",
                    h('div',{ id:d.data.attrs.id+'_label' },[d])
                  ]);
              }
                return h('td',{},[d1]);
            });
            return h('table',{ class:'centered'},[h('tr',{}, tds)]);
        }
    }
</script>
<style scoped>
   td{
      padding-top:5px;
   }
</style>
